import Reflux from 'reflux'
import Proxies from 'Components/proxies'
const { GET, POST } = Proxies
import keyMirror from 'keymirror'
import 'moment/locale/da'

export const STATUS = keyMirror({
  IS_FETCHING: null,
  FETCHING_ERROR: null,
  UPDATE_SUCCESS: null,
  UPDATE_ERROR: null,
  DELETE_ERROR: null,
  DELETE_LINK_ERROR: null,
  DELETE_SUCCESS: null,
  TAKING_INPUT: null,
  IS_SAVING: null,
  REDIRECT: null,
  SAVE_LINK_ERROR: null
})

export const ExpectedDeliveryStatusActions = Reflux.createActions([
  'getExpectedDeliveryStatuses',
  'deleteExpectedDeliveryStatus',
  'clearToast',
  'createEmptyExpectedDeliveryStatus',
  'clearFormToast',
  'updateExpectedDeliveryStatusField',
  'saveExpectedDeliveryStatus',
  'getExpectedDeliveryStatusDetails',
  'deleteVariationLink',
  'deleteProductLink',
  'deleteSupplierLink',
  'saveExpectedDeliveryStatusLink',
  'setAddLinkModalType',
  'fetchSupplierLinks',
  'getSuppliers'
])

export class ExpectedDeliveryStatusStore extends Reflux.Store {
  constructor(props) {
    super(props)
    this.listenables = ExpectedDeliveryStatusActions
    this.state = {
      status: null,
      expectedDeliveryStatuses: [],
      expectedDeliveryStatusName: null,
      expectedDeliveryStatusDetails: {
        statusType: '',
        name: '',
        description: ''
      },
      variationLinks: [],
      productLinks: [],
      supplierLinks: [],
      allSupplierLinks: [],
      showAddLinkModalType: null,
      suppliers: []
    }
  }

  getExpectedDeliveryStatuses() {
    if (this.state.status === STATUS.IS_FETCHING) {
      return
    }

    this.setState({ status: STATUS.IS_FETCHING })
    GET('expectedDeliveryStatuses/pool').then(responseJSON => {
      let nextState = {
        expectedDeliveryStatuses: []
      }
      if (responseJSON) {
        if (responseJSON.error) {
          nextState.status = STATUS.FETCHING_ERROR
        } else {
          nextState.expectedDeliveryStatuses = responseJSON
          nextState.status = null
        }
      }
      this.setState(nextState)
    })
  }

  clearToast() {
    this.setState({ status: null })
  }

  deleteExpectedDeliveryStatus(id = null) {
    if (id) {
      POST('expectedDeliveryStatuses/remove', { ExpectedDeliveryStatusID: id }).then(responseJSON => {
        if (responseJSON.error) {
          this.setState({ status: STATUS.DELETE_ERROR })
        } else {
          this.getExpectedDeliveryStatuses()
        }
      })
    }
  }

  deleteVariationLink(VariationExpectedDeliveryStatusID) {
    if (this.state.expectedDeliveryStatusDetails && VariationExpectedDeliveryStatusID) {
      POST('expectedDeliveryStatuses/removeVariationLink', { VariationExpectedDeliveryStatusID: VariationExpectedDeliveryStatusID }).then(
        responseJSON => {
          if (responseJSON.error) {
            this.setState({ status: STATUS.DELETE_LINK_ERROR })
          } else {
            this.setState({
              variationLinks: this.state.variationLinks.filter(link => link.VariationExpectedDeliveryStatusID !== VariationExpectedDeliveryStatusID)
            })
          }
        }
      )
    }
  }

  deleteProductLink(ProductExpectedDeliveryStatusID) {
    if (this.state.expectedDeliveryStatusDetails && ProductExpectedDeliveryStatusID) {
      POST('expectedDeliveryStatuses/removeProductLink', { ProductExpectedDeliveryStatusID: ProductExpectedDeliveryStatusID }).then(responseJSON => {
        if (responseJSON.error) {
          this.setState({ status: STATUS.DELETE_LINK_ERROR })
        } else {
          this.setState({
            productLinks: this.state.productLinks.filter(link => link.ProductExpectedDeliveryStatusID !== ProductExpectedDeliveryStatusID)
          })
        }
      })
    }
  }

  deleteSupplierLink(SupplierExpectedDeliveryStatusID) {
    if (this.state.expectedDeliveryStatusDetails && SupplierExpectedDeliveryStatusID) {
      POST('expectedDeliveryStatuses/removeSupplierLink', { SupplierExpectedDeliveryStatusID: SupplierExpectedDeliveryStatusID }).then(
        responseJSON => {
          if (responseJSON.error) {
            this.setState({ status: STATUS.DELETE_LINK_ERROR })
          } else {
            this.setState({
              supplierLinks: this.state.supplierLinks.filter(link => link.SupplierExpectedDeliveryStatusID !== SupplierExpectedDeliveryStatusID),
              allSupplierLinks: this.state.allSupplierLinks.filter(link => link.SupplierExpectedDeliveryStatusID !== SupplierExpectedDeliveryStatusID)
            })
          }
        }
      )
    }
  }

  createEmptyExpectedDeliveryStatus() {
    this.setState({
      expectedDeliveryStatusDetails: {
        statusType: '',
        name: '',
        description: ''
      }
    })
  }

  clearFormToast(status) {
    status ? this.setState({ status }) : this.setState({ status: STATUS.TAKING_INPUT })
  }

  getExpectedDeliveryStatusDetails(id = null) {
    if (!id) {
      return
    }

    this.setState({ status: STATUS.IS_FETCHING })
    GET('expectedDeliveryStatuses/fetch', { ExpectedDeliveryStatusID: id }).then(responseJSON => {
      let nextState = {
        expectedDeliveryStatusDetails: {}
      }
      if (responseJSON) {
        if (responseJSON.error) {
          nextState.status = STATUS.FETCHING_ERROR
        } else {
          nextState.expectedDeliveryStatusDetails = responseJSON.expectedDeliveryStatus
          nextState.productLinks = responseJSON.productLinks
          nextState.variationLinks = responseJSON.variationLinks
          nextState.supplierLinks = responseJSON.supplierLinks
          nextState.status = STATUS.TAKING_INPUT
        }
      }
      this.setState(nextState)
    })
  }

  updateExpectedDeliveryStatusField(field) {
    let fieldName = field.target.name
    let fieldValue
    if (fieldName === 'isActive' || fieldName === 'isHideable') {
      fieldValue = field.target.checked ? 1 : 0
    } else if (fieldName === 'poolOrder') {
      fieldValue = Number(field.target.value)
    } else {
      fieldValue = field.target.value
    }
    let expectedDeliveryStatusDetails = this.state.expectedDeliveryStatusDetails
    expectedDeliveryStatusDetails[fieldName] = fieldValue
    this.setState({ expectedDeliveryStatusDetails })
  }

  saveExpectedDeliveryStatus() {
    let expectedDeliveryStatusDetails = this.state.expectedDeliveryStatusDetails
    if (!expectedDeliveryStatusDetails.timeEnd) {
      expectedDeliveryStatusDetails.timeEnd = null
    }
    this.setState({ status: STATUS.IS_SAVING })
    POST('expectedDeliveryStatuses/replace', expectedDeliveryStatusDetails).then(responseJSON => {
      if (responseJSON) {
        if (responseJSON.error) {
          this.setState({ status: STATUS.UPDATE_ERROR })
        } else {
          this.setState({ status: STATUS.UPDATE_SUCCESS })
        }
      }
    })
  }

  async saveExpectedDeliveryStatusLink(linkType, linkData) {
    const responseJson = await POST(`expectedDeliveryStatuses/add${linkType}Link`, linkData)
    if (responseJson && !responseJson.error) {
      this.setState(
        linkType === 'Product'
          ? { productLinks: [...this.state.productLinks, responseJson] }
          : linkType === 'Variation'
          ? { variationLinks: [...this.state.variationLinks, responseJson] }
          : { supplierLinks: [...this.state.supplierLinks, responseJson], allSupplierLinks: [...this.state.allSupplierLinks, responseJson] }
      )
    } else {
      this.setState({ status: STATUS.SAVE_LINK_ERROR })
    }
  }

  setAddLinkModalType(showAddLinkModalType) {
    this.setState({ showAddLinkModalType: showAddLinkModalType })
  }

  async fetchSupplierLinks() {
    if (this.state.status === STATUS.IS_FETCHING) {
      return
    }
    this.setState({ status: STATUS.IS_FETCHING })
    const responseJson = await GET('expectedDeliveryStatuses/poolSupplierLinks')
    if (responseJson && !responseJson.error) {
      this.setState({ allSupplierLinks: responseJson, status: null })
    } else {
      this.setState({ allSupplierLinks: [], status: STATUS.FETCHING_ERROR })
    }
  }

  getSuppliers() {
    GET('suppliers/pool').then(responseJSON => {
      if (responseJSON && !responseJSON.error) {
        this.setState({ suppliers: responseJSON })
      }
    })
  }
}
